// LIBRARY
import React from 'react'
// @ts-ignore
import {  Switch, Form, Input, Button, Col, Row } from 'antd'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';
import HttpCodeMessage from 'shared_components/message_http_status'
import { createExamListAPI, updateExamListAPI } from 'services/blood_bank/exam_list';
import { buttonLabels, drawerAdd, messagePrompts } from '../settings'
// CSS
import './form.css';

// @ts-ignore
const { TextArea } = Input;

class ExamListForm extends React.Component {
	constructor(props) {
    super(props);
    this.state = {
			disabled: true,
    };
	} 


  onFinish = async (values) => {
		const loggedinUser = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));
		const { drawerButton, selectExam } = this.props;

    	const payload = {
			exam_item_id: selectExam.exam_item_id,
			exam_item_name: values.exam_item_name,
			exam_item_desc: values.exam_item_desc,
			evaluation_type: values.evaluation_type,
			is_mandatory: true,
			is_active: (drawerButton === drawerAdd ? true : values.is_active), 
			last_updated_by: loggedinUser.userID,
			created_by: loggedinUser.userID
			};
            console.log("🚀 ~ file: index.js ~ line 40 ~ ExamListForm ~ onFinish= ~ payload", payload)

			if(drawerButton === drawerAdd){
					const createExamListResponse = await createExamListAPI(payload);
					// @ts-ignore
					if(createExamListResponse.status === 201){
						const httpMessageConfig = {
							message: messagePrompts.successCreateUser,
							// @ts-ignore
							status: createExamListResponse.status,	
							duration: 3, 
							onClose: () => window.location.reload() 
						}
						HttpCodeMessage(httpMessageConfig);	
					}	
		}
		else {
			
			const updateExamListResponse =  await updateExamListAPI(payload)
			// @ts-ignore)
			if(updateExamListResponse.status === 200){
				const httpMessageConfig = {
					message: messagePrompts.successUpdateUser,
					// @ts-ignore
					status: updateExamListResponse.status,
					duration: 3, 
					onClose: () => window.location.reload() 
				}
				HttpCodeMessage(httpMessageConfig);
			}
		}
	};

  onDisable = () => {
    this.setState({ disabled:false })
  }
    
	render() {
		// @ts-ignore
		const { disabled } = this.state
		const { drawerButton,selectExam } = this.props;
			return(
				<div style={{marginTop: -10}}>
					<Form 
						layout="vertical"
						onFinish={this.onFinish} 
						initialValues={{ 
							is_active: selectExam.is_active === true ,
							exam_item_id:selectExam.exam_item_id,
							exam_item_name:selectExam.exam_item_name,
							exam_item_desc: selectExam.exam_item_desc,
							evaluation_type: selectExam.evaluation_type,
						}}  
					>
						{
							drawerButton === "UPDATE"
							? 
								(		
									<Row>
										<Col span={4}>	
											<Form.Item >
												<label >ACTIVE:</label> 	
											</Form.Item>
										</Col>
	
										<Col span={6}>	
											<Form.Item name='is_active' valuePropName='checked' >
												<Switch onChange={this.onDisable}/>
											</Form.Item>
										</Col>
									</Row> 
								)	
							:
							null
						}
						<Form.Item	 
							label="EXAM NAME" 
							name='exam_item_name'
							style={{marginTop:10}}
							rules={[{ required: true, message: 'Please input Exam Name!' }]} 
						>
								<Input style={{ textTransform: 'uppercase'}}  onChange={this.onDisable}/>		
						</Form.Item>
						<Form.Item 
							label="EVALUATION TYPE" 
							name='evaluation_type' 
							style={{marginTop: 10}}
						>
								<Input style={{ textTransform: 'uppercase'}}  onChange={this.onDisable}/>	
						</Form.Item>
						<Form.Item 
							label="EXAM DESCRIPTION" 
							name='exam_item_desc' 
							style={{marginTop: 10}}
						>
								<TextArea rows={4} onChange={this.onDisable}/>
						</Form.Item>
						<section className="drawerFooter">
							<Button 
							shape="round" 
							style={{ marginRight: 8, width: 120 }} 
							onClick={this.props.onClose}>
								{buttonLabels.cancel}
							</Button>
							<Button 
								disabled={disabled} 
								type="primary" 
								shape="round" 
								style={{ margin: 10, width: 120 }} 
								htmlType="submit"
							>
								{drawerButton}
							</Button>
						</section>
				  </Form>
				</div>
			);
	}
}

ExamListForm.propTypes = {
	drawerButton: PropTypes.string.isRequired,
	onClose: PropTypes.func,
	actionType: PropTypes.string.isRequired,
	patientInfo: PropTypes.array.isRequired,
	selectExam:PropTypes.object.isRequired,
	form: PropTypes.object
}

// @ts-ignore
export default withRouter(ExamListForm);